import "../css/style.scss";

export default function PrivacyPolicy() {
  return (
    <section>
      <div className="privacy-policy">
        <h1>Privacy Policy</h1>
        <p>
          This website respects your privacy. We do not collect, store, or share any personal information about our
          visitors.
        </p>

        <h2>No Data Collection</h2>
        <p>We do not collect any personal data, browsing data, cookies, analytics, or tracking information.</p>

        <h2>No Third-Party Sharing</h2>
        <p>Since we do not collect any information, we do not sell, share, or disclose your data to third parties.</p>

        <h2>Cookies & Tracking</h2>
        <p>Our website does not use cookies, beacons, or any tracking technologies.</p>

        <h2>External Links</h2>
        <p>
          If our website contains links to other websites, please note that we are not responsible for their privacy
          practices. We encourage you to review the privacy policies of those external sites.
        </p>

        <h2>Changes to This Policy</h2>
        <p>
          If we ever make changes to how the website works, we will update this policy accordingly. If you have any
          questions about this Privacy Policy, you may contact us at: hi@airguslar.com.
        </p>
      </div>
    </section>
  );
}
